import React, { useEffect } from "react";
import { Title, Text } from "../dynamic.components";
import { useStore } from "src/store";
import { playCustomAnimation } from "src/services/animations";
import {
  componentAnimationReadyToPlay,
  componentAnimationReadyToStop,
} from "src/utils/helper";

export const Baffles: React.FC = (): JSX.Element => {
  const {
    sidebarStatus,
    animationStopped,
    setAnimationStopped,
    activeSubLink: { text },
  } = useStore();

  useEffect(() => {
    if (componentAnimationReadyToPlay("2-1")) {
      playCustomAnimation();
    }
    if (componentAnimationReadyToStop("2-1")) {
      setAnimationStopped(true);
    }
  }, [sidebarStatus, animationStopped]);

  return (
    <>
      <Title title={text} />
      <div className="c-sidebar__body">
        <Text text="Baffles are integral to vessel wall. Their positioning is based on computational fluid dynamic modeling to provide efficient mixing. " />
      </div>
    </>
  );
};
